// CryptoTickerWidget/CryptoTickerTriggerDispatcher.js
// Per-instance. extends CoreBase for logError. _handlers-map pattern (rk=6c294559).
// CoreBase calls nothing on construction — caller must explicitly call initialize()
// right after `new CryptoTickerTriggerDispatcher(...)`.
import CoreBase from '../../../services/engines/CoreBase';
import TriggerKind from '../Types/TriggerKind';

class CryptoTickerTriggerDispatcher extends CoreBase {
  /**
   * @param {{triggerKind: string, debounceMs?: number, intervalMs?: number}} config
   * @param {function} onPaint - called with (state) when a repaint should happen
   */
  constructor(config, onPaint) {
    super();
    this._config = config;
    this._onPaint = onPaint;
    this._timer = null;

    this._handlers = {
      [TriggerKind.ON_DATA_RECEIVED]: this._handleOnDataReceived,
      [TriggerKind.ON_TIMER_ELAPSED]: this._handleOnTimerElapsed,
    };
  }

  /**
   * Sets _name for logging. Must be called once by the caller right after construction.
   */
  initialize() {
    this._name = 'CryptoTickerTriggerDispatcher';
  }

  /**
   * Called by the cache whenever new state is ingested (onDataBufferUpdated).
   * @param {object} state
   */
  dispatch = (state) => {
    try {
      const handler = this._handlers[this._config.triggerKind];
      if (!handler) return;
      handler(state);
    } catch (error) {
      this.logError('dispatch', error.message);
    }
  };

  _handleOnDataReceived = (state) => {
    this._onPaint(state);
  };

  _handleOnTimerElapsed = (state) => {
    if (this._timer) return;
    this._timer = setTimeout(() => {
      this._onPaint(state);
      this._timer = null;
    }, this._config.intervalMs || 1000);
  };
}

export default CryptoTickerTriggerDispatcher;
